import * as Yup from 'yup';

const enabledStepsErrorMessage =
  "L'adresse doit au moins avoir des informations postales, de localisation ou cadastrales.";

const typeIdsErrorMessage = "L'adresse doit avoir au moins un type.";

export const GeneralInfoSchema = Yup.object().shape({
  typeIds: Yup.array()
    .of(Yup.string().required(typeIdsErrorMessage))
    .required(typeIdsErrorMessage)
    .min(1, typeIdsErrorMessage),
  enabledSteps: Yup.array()
    .of(Yup.string().required())
    .required(enabledStepsErrorMessage)
    .min(1, enabledStepsErrorMessage),
  postalInfo: Yup.object().optional().nullable(),
  locationInfo: Yup.object().optional().nullable(),
  cadastralInfo: Yup.object().optional().nullable(),
});
